<template>
  <div>
    <p>Sign-in in progress</p>
    <v-progress-circular color="primary" indeterminate></v-progress-circular>
  </div>
</template>

<script>
export default {
  async created () {
    try {
      var result = await this.$root.mgr.signinRedirectCallback()
      var returnToUrl = '/'
      if (result.state !== undefined) { returnToUrl = result.state }
      this.$router.push({ path: returnToUrl })
    } catch (e) {
      console.log(e)
      this.$router.push({ path: '/' })
    }
  }
}
</script>
